// extracted by mini-css-extract-plugin
export var errorsContainer = "_u8-1";
export var link = "_u8-0";